import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import some from "lodash/some";
import isEmpty from "lodash/isEmpty";
import { logoutUser } from '../../app-main/actions/auth';
import publicConfig from '../../../../public-config';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { LocaleSelector } from 'shared-components/internationalization/locale-selector';
import { SearchSmall, ArrowDownSmall } from 'shared-components/icons';

class DefaultNav extends Component {
  constructor (props) {
    super(props);

    this.state = {
      hasMounted: false
    };

    this.logout = this.logout.bind(this);
  }

  componentDidMount () {
    this.setState({
      hasMounted: true
    });
  }

  logout (e) {
    e.preventDefault();
    const { dispatch } = this.props;

    dispatch(logoutUser());
  }

  sendReferralNavClickAnalytics () {
    analyticsIntegrations.trackReferralClick('nav');
  }

  renderImage () {
    const { profile } = this.props;
    const { data } = profile;

    if (data && data.avatar_url) {
      return <img className="img-circle" src={data.avatar_url} />;
    }

    return <img className="img-circle" src="/web-2/assets/images/no_avatar_placeholder.svg?v=rb" />;
  }

  renderSearch () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    return (
      <li>
        <a id="header_link_search" className="search" onClick={() => this.props.toggleSearchWidgetFn()} >
          <SearchSmall className="margin-sm-right" width={20} height={20} />
          <FormattedMessage id='shared_component.nav.search' defaultMessage='Search'/>
        </a>
      </li>
    );
  }

  renderMessages () {
    const { nav } = this.props;

    if (nav.messageCount) {
      return <span className="menu-message-bubble">{ nav.messageCount }</span>;
    }

    return null;
  }

  renderListings (isBoxMenu) {
    const { profile, nux = {} } = this.props;
    const { data } = profile;
    const listClass = isBoxMenu ? 'visible-menu-item' : 'menu-listings hidden-menu-item';
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'mylistings-new-badge' });

    if (data && data.is_host) {
      return (
        <li className={listClass}>
          <a className="nav-link" href="/mylistings">
            <FormattedMessage id='shared_component.nav.listings' defaultMessage='Listings'/>
          </a>
          {
            badgeExp &&
            <span className="v-center text-pale-blue text-small new-notification">
              <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
            </span>
          }
        </li>
      );
    }
    return null;
  }

  renderBoards (isBoxMenu) {
    const { profile } = this.props;
    const { data } = profile;
    if (data) {
      const listClass = !isBoxMenu ? 'menu-listings hidden-menu-item' : data.is_host ? '' : 'visible-menu-item';
      if (!data.is_host || isBoxMenu) {
        return (
          <li className={listClass}>
            <a href='/boards'>
              <FormattedMessage id='shared_component.nav.boards' defaultMessage='Boards'/>
            </a>
          </li>
        );
      }
    }
    return null;
  }

  renderCalendar (isBoxMenu) {
    const { profile = {}, nux = {} } = this.props;
    const { data = {} } = profile;
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'calendar-new-badge' });
    const listClass = isBoxMenu ? 'visible-menu-item' : 'hidden-menu-item';
    if (data && data.is_host) {
      return (
        <li className={`menu-calendar ${listClass}`}>
          <a className="nav-link" href="/calendar">
            <FormattedMessage id='shared_component.nav.calendar' defaultMessage='Calendar'/>
          </a>
          {
            badgeExp ?
              <span className="v-center text-pale-blue text-small new-notification">
                <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
              </span> : null
          }
        </li>
      );
    }
    return null;
  }

  renderAddons (isBoxMenu) {
    const { profile = {}, nux = {} } = this.props;
    const { data = {} } = profile;
    const completeExp = get(nux, ['experiences'], []);
    const badgeExp = some(completeExp, { name: 'addons-new-badge' });
    const listClass = isBoxMenu ? 'visible-menu-item' : 'hidden-menu-item';
    if (data && data.is_host) {
      return (
        <li className={`menu-item ${listClass}`}>
          <a className="nav-link" href="/hosting/add-ons">
            <FormattedMessage id='shared_component.nav.add_ons' defaultMessage='Add-ons'/>
          </a>
          {
            badgeExp &&
            <span className="v-center text-pale-blue text-small new-notification">
              <FormattedMessage id='shared_component.nav.new' defaultMessage='NEW!'/>
            </span>
          }
        </li>
      );
    }
    return null;
  }

  renderHostForum (isBoxMenu) {
    const { profile } = this.props;
    const { data } = profile;
    const listClass = isBoxMenu ? 'hidden-lg' : 'visible-lg visible-xl';

    if (data && data.is_host) {
      return (
        <li className={`menu-forum ${listClass}`}>
          <a href="https://community.peerspace.com"><FormattedMessage id='shared_component.nav.community' defaultMessage='Community'/></a>
        </li>
      );
    }

    return null;
  }

  renderPayoutError (isMobile) {
    const { nav, profile, location } = this.props;
    const { data, bankStatus } = profile;
    const { managedAccount } = nav;
    const detailsSubmitted = get(managedAccount, 'details_submitted');
    const combinedRequirements = get(managedAccount, 'combined_requirements');
    const bankAcctSubmitted = 1 <= (get(managedAccount, 'external_accounts.data') || []).length;
    const listClass = isMobile ? 'visible-sm visible-xs visible-md visible-lg' : 'hidden-xs hidden-sm hidden-md hidden-lg';
    const newHost = managedAccount && (!detailsSubmitted || !bankAcctSubmitted);
    const peerspaceCanDistributeHostFunds = !('manual' === get(managedAccount, 'settings.payouts.schedule.interval'));
    const hostNeedsToEnablePayout = managedAccount && (!managedAccount.payouts_enabled || !peerspaceCanDistributeHostFunds) && !isEmpty(combinedRequirements);

    if (newHost) {
      return (
        <li className={`menu-add-payout-info ${listClass}`}>
          <a href="/account/host">
            <FormattedMessage id='shared_component.nav.add_payout' defaultMessage='Add Payout Info'/>
          </a>
        </li>
      );
    } else if (hostNeedsToEnablePayout || data.external_accounts_error) {
      return (
        <li className={`menu-payouts-blocked ${listClass}`}>
          <a href={data.external_accounts_error ? '/account/methods' : '/account/verify'}>
            <i className="ico icon-attention" /><FormattedMessage id='shared_component.nav.payout_blocked' defaultMessage='Payouts Blocked'/>
          </a>
        </li>
      );
    }

    return null;
  }

  renderReferral (showReferral) {
    if (showReferral) {
      return (
        <li className="menu-item hidden-menu-item" onClick={this.sendReferralNavClickAnalytics}>
          <a className="earn-more" href="/referrals" id="header_link_referrals">
            <img style={{ width: 20, marginBottom: 6 }}
              className="margin-md-right"
              src="https://assets.peerspace.com/gift-primary.svg?v=rb"
              alt={this.props.intl.formatMessage({ id: 'shared_component.nav.earn_50_alt', defaultMessage: 'gift' })}
            />
            <span><FormattedMessage id='shared_component.nav.earn_50' defaultMessage='Earn $50'/></span>
          </a>
        </li>
      );
    }
    return null;
  }

  renderControls () {
    const { accessToken, location = {}, profile, intl, envLocaleData } = this.props;
    const isHost = get(profile, 'data.is_host');
    const pathname = location.pathname || '';
    const isBlackListLanguage = 'en-US' !== intl.locale;
    const redirectLocation = pathname ? `?dest=${encodeURIComponent(pathname)}` : '';
    const showReferral = !publicConfig.hideReferral && !isBlackListLanguage && !profile.isFetching && profile.hasFetched && !isHost;
    const showReferralForHost = !publicConfig.hideReferral && !isBlackListLanguage && !profile.isFetching && profile.hasFetched;
    const prefix = SharedIntlProviderHOC.getUrlPrefix();
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
    const urlPrefix = prefix?`/${prefix}`:'';

    if (accessToken) {
      return (
        <ul className="nav navbar-nav navbar-right nav-logged-in" id="navbar-right">
          <li>
            <a>
              <LocaleSelector source="navbar" activeLocales={envLocaleData}>
                <img width={20} height={20} className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
              </LocaleSelector>
            </a>
          </li>
          { this.renderPayoutError(false) }
          { this.renderReferral(showReferral) }
          <li className="menu-messages hidden-menu-item">
            <a href="/inbox">
              <FormattedMessage id='shared_component.nav.inbox' defaultMessage='Inbox'/>
              { this.renderMessages() }
            </a>
          </li>
          <li className="menu-bookings hidden-menu-item"><a href='/bookings'><FormattedMessage id='shared_component.nav.bookings' defaultMessage='Bookings'/></a></li>
          { this.renderListings() }
          { this.renderCalendar() }
          { this.renderAddons() }
          { this.renderBoards() }
          { this.renderHostForum() }
          <li id="profileDropdown" className="dropdown profile-dropdown">
            <a href="components/src/app-main/components#" className="dropdown-toggle profile-menu text-white" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              { this.renderImage() }
              <ArrowDownSmall width={24} height={24}/>
            </a>
            <ul className="dropdown-menu dropdown-menu-right profile-menu-dropdown">
              { this.renderPayoutError(true) }
              <div className="arrow-up"></div>
              <li className="visible-menu-item">
                <a href="/inbox">
                  <FormattedMessage id='shared_component.nav.inbox' defaultMessage='Inbox'/>
                  { this.renderMessages() }
                </a>
              </li>
              <li className="visible-menu-item"><a href='/bookings'><FormattedMessage id='shared_component.nav.bookings' defaultMessage='Bookings'/></a></li>
              { this.renderListings(true) }
              { this.renderCalendar(true) }
              { this.renderAddons(true) }
              { this.renderHostForum(true) }
              <li><a href="/reviews/about-you"><FormattedMessage id='shared_component.nav.reviews' defaultMessage='Reviews'/></a></li>
              { this.renderBoards(true) }
              <li><a href="/profile"><FormattedMessage id='shared_component.nav.profile' defaultMessage='Profile'/></a></li>
              <li><a href="/account"><FormattedMessage id='shared_component.nav.payments' defaultMessage='Payments'/></a></li>
              {
                showReferralForHost
                && [
                  <li role="separator" className={`divider ${!isHost && "visible-xs"}`} />,
                  <li className={`${!isHost && "visible-xs"}`} onClick={this.sendReferralNavClickAnalytics}>
                    <a className="earn-more" href='/referrals' id="menu_link_referrals">
                      <img style={{ width: 20, marginBottom: 6 }}
                        className="margin-md-right"
                        src="https://assets.peerspace.com/gift-primary.svg?v=rb"
                        alt={this.props.intl.formatMessage({ id: 'shared_component.nav.earn_50_alt', defaultMessage: 'gift' })}
                      />
                      <span><FormattedMessage id='shared_component.nav.earn_50' defaultMessage='Earn $50'/></span>
                    </a>
                  </li>
                ]
              }
              <li role="separator" className="divider"></li>
              <li><a className="add-a-space-menu" href="/your-space/create"><FormattedMessage id='shared_component.nav.add_space' defaultMessage='Add a Space'/></a></li>
              <li><a href={`https://support.peerspace.com/hc/${zendeskLocale}`}><FormattedMessage id='shared_component.nav.help' defaultMessage='Help'/></a></li>
              <li>
                <a className="logout" onClick={ this.logout }><FormattedMessage id='shared_component.nav.logout' defaultMessage='Log Out'/></a>
              </li>
            </ul>
          </li>
        </ul>
      );
    }

    return (
      <ul className="nav navbar-nav navbar-right nav-logged-out">
        <li>
          <a>
            <LocaleSelector source="navbar" activeLocales={envLocaleData}>
              <img width={20} height={20} className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
            </LocaleSelector>
          </a>
        </li>
        <li>
          <a id="header_link_add_space" className="add-a-space" href="/host">
            <span><FormattedMessage id='shared_component.nav.list_space' defaultMessage='List Your Space'/></span>
          </a>
        </li>
        <li>
          <a id="header_link_signup" href={`${urlPrefix}/signin#a=signup&source=nav`}><FormattedMessage id='shared_component.nav.signup' defaultMessage='Sign Up'/></a>
        </li>
        <li>
          <a id="header_link_signin" href={`${urlPrefix}/signin${redirectLocation}`}><FormattedMessage id='shared_component.nav.login' defaultMessage='Log In'/></a>
        </li>
      </ul>
    );
  }

  renderCollapse () {
    const { profile } = this.props;

    if (profile) {
      return (
        <div>
          <button type="button" id="navbar-mobile-button" className="logged-in navbar-toggle text-white" data-toggle="collapse" data-target="#listing-navbar" aria-expanded="false">
            <span className="sr-only"><FormattedMessage id='shared_component.nav.toggle_nav' defaultMessage='Toggle navigation'/></span>
            { this.renderImage() }
            <ArrowDownSmall width={24} height={24}/>
          </button>
        </div>
      );
    }

    return (
      <div>
        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#listing-navbar" aria-expanded="false">
          <span className="sr-only"><FormattedMessage id='shared_component.nav.toggle_nav' defaultMessage='Toggle navigation'/></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </div>
    );
  }

  render () {
    const { hasMounted } = this.state;
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    return (
      <div className="container-fluid">
        <div className="navbar-header">
          { this.renderCollapse() }
          <a id="header_link_home" className="navbar-brand" href={`/${urlPrefix}`}>
            <img className="brand-logo-white" src="/web-2/assets/images/ps_logo_white.svg?v=rb" alt={this.props.intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })} />
            <img className="brand-logo-dark" src="/web-2/assets/images/ps_logo_dark.svg?v=rb" alt={this.props.intl.formatMessage({ id: 'shared_component.nav.logo_alt', defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots' })} />
          </a>
          <ul id="navbar-search" className="nav navbar-nav pull-right">
            { this.renderSearch() }
          </ul>
        </div>

        <div className="collapse navbar-collapse" id="listing-navbar">
          { hasMounted && this.renderControls() }
        </div>
      </div>
    );
  }
}

DefaultNav.propTypes = {
  accessToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  nav: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  nux: PropTypes.object.isRequired,
  location: PropTypes.object,
  intl: intlShape
};

export default injectIntl(DefaultNav);
